import { render, staticRenderFns } from "./readView.vue?vue&type=template&id=789fe040&scoped=true"
import script from "./readView.vue?vue&type=script&lang=js"
export * from "./readView.vue?vue&type=script&lang=js"
import style0 from "./readView.vue?vue&type=style&index=0&id=789fe040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789fe040",
  null
  
)

export default component.exports